import { InlineLink } from "../ReusableStyledComponents/InlineLink";
import { BannerDetails } from "../BannerDetails";

interface NoNameBannerProps {
    /** The noun shown in the banner copy, e.g. "collection" or "page". */
    entity: string;
    /** The current default name shown to visitors, e.g. "Untitled Page 7". When set, the banner surfaces it in the copy. */
    name?: string;
    onNameClick: () => void;
}

export const NoNameBanner = ({ entity, name, onNameClick }: NoNameBannerProps) => {
    return (
        <BannerDetails useYellow allowUserThemable>
            {name ? (
                <>
                    This {entity} is showing as &quot;{name}&quot; in your navigation.
                </>
            ) : (
                <>This {entity} does not have a name yet.</>
            )}{" "}
            <InlineLink onClick={onNameClick}>Name it now</InlineLink>.
        </BannerDetails>
    );
};
